import { Pipe, PipeTransform } from '@angular/core';
import {CensusAgeGroup} from '../../types/nso-data-portal/census-data';

@Pipe({
  name: 'ageGroupType'
})
export class AgeGroupTypePipe implements PipeTransform {

  transform(censusAgeGroups: CensusAgeGroup[], type: string): CensusAgeGroup[] {
    if (!censusAgeGroups || !type) {
      return censusAgeGroups;
    }
    return censusAgeGroups.filter(
      censusAgeGroup => censusAgeGroup.ageGroupData.groupType === type
    );
  }

}
